import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/BroadcastRecorderList.vue"),
    meta: {
      title: "Broadcast Recorders",
    },
    name: "broadcast-recorder-list",
    path: "/broadcast-recorders",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/BroadcastRecorderEdit.vue"),
    meta: {
      title: "New Broadcast Recorder",
    },
    name: "broadcast-recorder-new",
    path: "/broadcast-recorders/new",
  },
  {
    component: () => import("pages/BroadcastRecorderEdit.vue"),
    meta: {
      title: "Edit Broadcast Recorder",
    },
    name: "broadcast-recorder-edit",
    path: "/broadcast-recorders/:id/edit",
    props: true,
  },
];
